import React, { useContext, useEffect } from 'react'
// import { connect } from 'react-redux'
// import { getBySlug, nextNavTo } from '@brainstud/react-helpers'
// import { setProgress } from '@brainstud/react-tbl/features/quiz/store'
// TODO get appRoutes from provider
// import { appRoutes } from '@brainstud/react-tbl/features'
import Intro from './Intro'
import { useSetProgress } from '../../store'

const IntroView = props => {
  useSetProgress('quiz', {
    location: 'intro',
    question: null,
  }, [props.location.pathname])

  return props.children || <Intro {...props} />
}

// class IntroView extends React.Component {
//   componentDidMount() {
//     // this.props.setProgress(this.props.quiz.id, {
//     //   location: 'intro',
//     // })
//   }
//
//   render() {
//     return <Intro {...this.props} />
//   }
// }

export default IntroView
// export default connect(
//   (state, props) => {
//     console.log(state)
    // const navigation = state.navigation.list.byId
    // const chapters = state.chapters.chapters.byId
    // const quizes = state.quizes.quizes.byId
    // const progressAll = state.quizes.progress
    // let navItem = false
    // let chapter = {}
    // let quiz = {}
    // let type = ''
    //
    // if(props.match.params.chapter) {
    //   chapter = getBySlug(chapters, props.match.params.chapter)
    //   navItem = Object.values(navigation).find(item => item.chapterId === chapter.id)
    //   quiz = quizes[chapter.quizId]
    //   type = 'quiz'
    // } else {
    //   navItem = Object.values(navigation).find(item => item.type === 'quiz')
    //   quiz = quizes[navItem.quizId]
    //   type = 'endtest'
    // }
    //
    // const progress = progressAll[quiz.id]
    // const nextTo = nextNavTo(state, navItem, appRoutes)
    //
    // return { quiz, type, progress, chapter: chapter ? chapter : false, nextTo }
  //   return { type: 'quiz' }
  // },
  // (dispatch) => ({
    // setProgress: (id, progress) => dispatch(setProgress(id, progress)),
//   })
// )(IntroView)
